import { clientEnvIsMacOs } from "./isMacOs";
import { clientEnvIsDesktop } from "./isDesktop";

export const clientEnvIsMacBrowser = (): boolean => {
  return clientEnvIsMacOs() && !clientEnvIsDesktop();
};
